define('edaphelpers',['edapUnderscore'], function(_) {
    'use strict';

    function EdapHelpers() {
        var helpers = this,
            defaultOpts = {
                ns: 'edap',
                dataLayerName: 'analyticsdatalayer'
            };


        /**
         *  Getter for the window object, mainly for spy-based testing and abstraction
         *
         *  @returns {Object} - The window object
         */
        helpers.getWindow = function() {
            return window;
        };


        /**
         *  Returns the window.edapOptions global contents
         *
         *  @returns {Object} - window.edapOptions global object
         */
        helpers.getGlobalOptions = function() {
            window.edapOptions = window.edapOptions || {};
            window.edapOptions = _.defaults(window.edapOptions, defaultOpts);
            return window.edapOptions;
        };


        /**
         *  Abstraction around getting the window-level EDAP singleton
         *
         *  @returns {Object} - Returns the window EDAP singleton
         */
        helpers.getEdapGlobal = function() {
            var win = helpers.getWindow(),
                ns = helpers.getGlobalOptions().ns,
                def = [],
                global = _.get(win, ns);

            if (!global) {
                _.set(win, ns, def);
                return def;
            }

            return global;
        };
    }

    return new EdapHelpers();
});

